import webBiLogger from '@wix/web-bi-logger';
import type { LogParams } from '@wix/web-bi-logger/dist/src/types';
import * as orionLogger from '@wix/bi-logger-scheduling-assistant-data/v2';
import type {
  bmModalActionSrc172Evid572Params,
  bmPageClickSrc172Evid522Params,
  bmPageLoadSrc172Evid501Params,
  LogObject,
} from '@wix/bi-logger-scheduling-assistant-data/v2/types';

const VARIANT = 'individuals';

// orion-web ships Orion + Symphony from one package, both under the shared
// `scheduling-assistant-data` BI schema. Log on every surface (only guard SSR, where
// there is no reporter). This previously gated to the Orion design brand, which silenced
// the flagship Symphony surface — the bare `symphony.wix.com` host (the `''` root mount) —
// leaving it with no analytics at all, while `/orion-web` and `/symphony-web` logged.
// web-bi-logger captures the host/URL, so the surfaces stay distinguishable in the data.
// Exported so the generic-events (src:198) mirror in `use-generic-bi.ts` applies the exact
// same gate as the src:172 events it shadows.
export const shouldLogBi = (): boolean => typeof window !== 'undefined';

const getExtraParam = (): Partial<{ variant: string }> => ({
  variant: VARIANT,
});

// Shared web-bi-logger instance. Exported so `GenericEventsBiLoggerProvider` can
// inject the same reporter — orion-web is not a yoshi-flow-bm app, so the generic
// events library has no `useBi()` to fall back on and needs a logger supplied.
export const orionBiReporter = webBiLogger.factory().logger();
orionBiReporter.updateDefaults({ _artifact_name: 'com.wixpress.nownia.orion-web' });
const reporter = orionBiReporter;

const logV2 = <T extends Record<string, unknown>>(event: LogObject<T>): void => {
  if (!shouldLogBi()) return;
  void reporter.report({
    evid: event.evid,
    src: event.src,
    endpoint: event.endpoint,
    params: event.params as LogParams,
  });
};

export const logPageLoadBi = (params: bmPageLoadSrc172Evid501Params) => {
  logV2(orionLogger.bmPageLoadSrc172Evid501({ ...params, ...getExtraParam() }));
};

export const logPageClickBi = (params: bmPageClickSrc172Evid522Params) => {
  logV2(orionLogger.bmPageClickSrc172Evid522({ ...params, ...getExtraParam() }));
};

export const logModalActionBi = (params: bmModalActionSrc172Evid572Params) => {
  logV2(orionLogger.bmModalActionSrc172Evid572({ ...params, ...getExtraParam() }));
};
